module.exports = __webpack_public_path__ + "static/media/th.e7f18a54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/th.svg
// module id = 1209
// module chunks = 39